export default {
  methods: {
    getIdFromCode (code) {
      let item = this.getSystemOptions('DESCRIPTOR_ENTITY_TYPE').find(obj => {
        return obj && obj.hasOwnProperty('code') && obj.code === code
      })
      return item ? item.id : null
    }
  },
  computed: {
    /*  2152 --> 2153 */
    sheetDescMain () {
      return this.getIdFromCode('MAIN')
    },
    /*  2153 --> 2154 */
    sheetDescAddition () {
      return this.getIdFromCode('LOOKUP_ADDITION')
    },
    /*  2154 --> 2155 */
    sheetDescAdditionField () {
      return this.getIdFromCode('LOOKUP_ADDITION_FIELD')
    },
    /*  2155 --> 2156 */
    sheetDescLookup () {
      return this.getIdFromCode('LOOKUP')
    },
    /*  2156 --> 2157 */
    sheetDescLookupHeader () {
      return this.getIdFromCode('LOOKUP_HEADER')
    },
    /*  2157 --> 2158 */
    sheetDescDetail () {
      return this.getIdFromCode('LOOKUP_DETAIL')
    },
    /*  2158 --> 2159 */
    sheetDescNote () {
      return this.getIdFromCode('LOOKUP_NOTE')
    },
    /*  2159 --> 2160 */
    sheetDescNoteField () {
      return this.getIdFromCode('LOOKUP_NOTE_FIELD')
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/SpreadsheetDescriptor/SheetMixin.js